var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 9.5,
    fill: "white",
    stroke: "#E2E4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4747 22.1079C40.6407 22.0367 40.8194 22 41 22C41.1806 22 41.3593 22.0367 41.5253 22.1079L59.6667 29.8839L41 37.8839L22.3333 29.8839L40.4747 22.1079ZM21 32.2145V52.6679C21 53.2012 21.32 53.6812 21.808 53.8945L39.6667 61.5479V40.2145L21 32.2145ZM42.3333 40.2145L61 32.2145V52.6679C61.0002 52.929 60.9238 53.1844 60.7801 53.4025C60.6365 53.6205 60.432 53.7916 60.192 53.8945L42.3333 61.5479V40.2145Z",
    fill: "#A4379E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.dcc3deb77b7248bcd337a0e1b3ddf5ef.svg";
export { ForwardRef as ReactComponent };